<template>
    <div>
        <div class="alert alert-danger">{{ $t('views.respira_pay.request_body') }}</div>
        <a class="btn btn-primary" :href="$t('views.respira_pay.mail')" target="_blank"><i class="las la-credit-card"></i>{{ $t('views.respira_pay.request_button') }}</a>
    </div>
</template>

<script>
    export default {
        name: "RespiraPayNotActivated"
    }
</script>

<style scoped>

</style>